import { render, staticRenderFns } from "./steps3.vue?vue&type=template&id=60a0b9b8&scoped=true&"
import script from "./steps3.vue?vue&type=script&lang=js&"
export * from "./steps3.vue?vue&type=script&lang=js&"
import style0 from "./steps3.vue?vue&type=style&index=0&id=60a0b9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0b9b8",
  null
  
)

export default component.exports